const SearchBlog = ({ setSearchQuery }) => {
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="col-xl-4 col-lg-4 theiaStickySidebar">
      {/* Search Bar */}
      <div className="card mb-3">
        {/* <div className="card-header border-0 pb-0">
          <div className="pb-3 border-bottom">
            <h5>
              <i className="isax isax-search-normal-1 text-primary fs-16 me-2"></i>
              Search
            </h5>
          </div>
        </div> */}
        {/* <div className="card-body pt-3"> */}
        <div className="bg-light-100 p-2 rounded border">
          <div className="input-icon">
            <span className="input-icon-addon">
              <i className="isax isax-search-normal-1 fs-14"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Tìm kiếm"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default SearchBlog;
